import React, { Suspense, useContext } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import useRoleBasedRoutes from './routes';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
import './assets/css/styles.css';

import Header from '../src/Views/Layouts/Header';
import NavigationBar from '../src/Views/Layouts/NavigationBar';
import { LayoutContext } from './Context/LayoutContext';
import RoleWrapper from './Config/RoleWrapper';
import Loader from './Views/Common/Loader';
import toast, { Toaster } from 'react-hot-toast';
function App() {
  const { userLoggedIn, mobileMenuOpen, currentUserRole, isMobile, mainLoader } =
    useContext(LayoutContext);
  //console.log(currentUserRole);
  const location = useLocation();
  const routes = useRoleBasedRoutes();
  const LoaderFallback = () => (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
  return (
    <div className={`main-wrapper ${mobileMenuOpen ? 'slide-nav' : ''}`}>
      {userLoggedIn && location.pathname !== '/' && (
        <>
          {mainLoader && <Loader isMobile={isMobile} />}
          <Header />
          <NavigationBar currentUserRole={currentUserRole} />
        </>
      )}
      <Suspense fallback={<LoaderFallback />}>
        <Routes>
          {routes.map((route, idx) => {
            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={
                    route.name === 'Login' ||
                    route.name === 'Forgot Password' ||
                    route.name === 'Reset Password' ? (
                      <route.element />
                    ) : (
                      <RoleWrapper>
                        <route.element />
                      </RoleWrapper>
                    )
                  }
                />
              )
            );
          })}
        </Routes>
      </Suspense>
      <Toaster />
    </div>
  );
}

export default App;
